import {
    AccessRight,
} from 'app/types/accessRights.types'
import locationAccessRights from 'app/access-rights/locationAccessRights'
import useHasPermissionType from './useHasPermissionType'

const useHasLocationPermissionType = (
    categories: string[],
    type?: keyof AccessRight,
) => {
    return useHasPermissionType(categories, locationAccessRights, type)
}

export default useHasLocationPermissionType
